import ProvablyFairHelper from "../../Components/ProvablyFairSystem/Index";

const ProvablyFairPage = () => {
  return <ProvablyFairHelper />;
};

export default ProvablyFairPage;
